<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8TjEJ8/tc-custom/9780369704351.jpg?1703681135351" alt="This image is the cover for the book Amish Innkeeper's Secret, Brides of Amish Country"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amish Innkeeper's Secret, Brides of Amish Country
      </h1>
      <p class="bookDescription body article font2">
        <b><i>USA Today</i>–Bestselling Author: Her hope for love was stolen by tragedy—but could a new arrival at her family’s inn bring a second chance?</b><br/><br/>Emma Wadler has made a good life for herself, running the Wadler Inn in the town of Hope Springs, Ohio. She has accepted her life as an “old maid,” and is content catering to the tourists who come to view her Amish community. She had once hoped to marry and raise a family of her own, but her fiancé died tragically when they were both only seventeen, and Emma has guarded her heart ever since.<br/><br/>Adam Troyer fixes things. Having just returned to the faith after years in the English world, Adam is hoping to prove to his father that he is committed to a simple life. So he’s happy to be hired by Emma’s mother to make repairs to the inn during the winter off-season. The old Swiss-style chalet has its share of problems, but nothing he can’t fix. Nothing except perhaps the broken heart of the owner. . . . <br/><br/><b>Praise for Patricia Davids’ novels</b><br/><br/>“Uplifting . . . will have fans of Amish romance eager to read more from Davids.” —<i>Publishers Weekly</i><br/><br/>“Patricia writes with heart, integrity and hope. Her stories both entertain and edify—the perfect combination.” —Kim Vogel Sawyer, bestselling author of <i>The Tapestry of Grace</i><br/><br/><i>Previously published as</i> The Inn at Hope Springs
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Davids
      </h2>
      
      <p class="authorDescription body article">USA Today best-selling author Patricia Davids was born in Kansas. After forty years as an NICU nurse, Pat switched careers to become an inspirational writer. She now enjoys laid back life on a Kansas farm, spending time with her family and playing with her dog Sugar, who thinks fetch should be a twenty-four hour a day game. When not throwing a ball, Pat is happily dreaming up new stories where love and faith conquer all. Contact her at pat@patriciadavids.com.<Br><Br>&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?63ca21d9